import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  text: {
    cursor: "pointer",
    display: "block",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    textDecoration: "underline",
    
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
}));
